/**
 * React Query cache key factories for the Module Configuration API.
 */

/** Cache keys for module configuration queries and mutations. */
export const moduleKeys = {
  all: ['modules'] as const,
  enabled: (clientId: string | null) => [...moduleKeys.all, 'enabled', clientId] as const,
  enabledSanitized: (clientId: string | null) =>
    [...moduleKeys.all, 'enabled-sanitized', clientId] as const,
  allConfigs: (clientId: string | null) => [...moduleKeys.all, 'all-configs', clientId] as const,
  available: () => [...moduleKeys.all, 'available'] as const,
  stats: () => [...moduleKeys.all, 'stats'] as const,
  config: (moduleId: string, clientId: string | null) =>
    [...moduleKeys.all, 'config', moduleId, clientId] as const,
};
